import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'dr-customer-offers-ui-cleared-container',
  templateUrl: './cleared-container.component.html',
  standalone: true,
  imports: [RouterModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClearedContainerComponent {
  protected isChartRoute$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => this.router.url.includes('/cleared/chart'))
  );

  constructor(private router: Router) {}
}
